import { ArrowRight, CheckCircle } from "lucide-react";
import { siteData } from "../../data/siteData";
import "./Hero.css";

export default function Hero() {
  const { company } = siteData;
  return (
    <section className="hero" id="home">
      <div className="hero__bg">
        <img
          src="https://paritama.com/wp-content/uploads/2026/04/1000157637-edited-scaled.jpg?w=1800&auto=format&fit=crop&q=80"
          alt="Taman indah Gemburin Sejahtera"
        />
      </div>

      <div className="hero__content">
        <div className="container" style={{ paddingTop: 140, paddingBottom: 180 }}>
          <div className="hero__badges anim-up" style={{ animationDelay: '.1s' }}>
            <span className="hero__pill"><span className="hero__pill-dot" /> Family-Owned &amp; Operated</span>
            <span className="hero__pill">✓ Berlisensi &amp; Terjamin</span>
            <span className="hero__pill">⭐ Kontraktor Penghijauan Terbaik</span>
          </div>

          <h1 className="hero__title anim-up" style={{ animationDelay: '.22s' }}>
            Kami Wujudkan <em>Taman</em><br />Impian Anda
          </h1>

          <p className="hero__desc anim-up" style={{ animationDelay: '.34s' }}>
            {company.description}
          </p>

          <div className="hero__actions anim-up" style={{ animationDelay: '.44s' }}>
            <a href={company.whatsapp} className="btn btn-green" target="_blank" rel="noreferrer">
              Konsultasi Gratis <ArrowRight size={16} />
            </a>
            <a href="#portofolio" className="btn btn-outline-white">
              Lihat Portofolio
            </a>
          </div>
        </div>

        {/* Stats strip */}
        {/* <div className="hero__strip">
          <div className="container hero__strip-inner">
            {company.stats.map((s) => (
              <div key={s.label} className="hero__stat">
                <div className="hero__stat-val">{s.value}</div>
                <div className="hero__stat-label">{s.label}</div>
              </div>
            ))}
          </div>
        </div> */}
      </div>
    </section>
  );
}
